import { Space } from 'antd';
import cx from 'classnames';
import React from 'react';
var MobileFooter = function MobileFooter(props) {
  var innerClassName = props.innerClassName,
    innerStyle = props.innerStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(innerClassName, 'dr-footer-inner'),
    style: innerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "dr-footer-inner-row"
  }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement("span", null, "Copyright\xA9"), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    className: "dr-footer-inner-item",
    href: "https://www.fanruan.com"
  }, "\u5E06\u8F6F\u8F6F\u4EF6\u6709\u9650\u516C\u53F8"), /*#__PURE__*/React.createElement("span", null, "\u7248\u6743\u6240\u6709"))), /*#__PURE__*/React.createElement("div", {
    className: "dr-footer-inner-row"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "dr-footer-inner-item",
    href: "https://beian.miit.gov.cn/#/Integrated/index",
    target: "_blank",
    rel: "noreferrer"
  }, "\u82CFICP\u590718065767\u53F7"))));
};
export default MobileFooter;